import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import CertificationTestExecutionListPending from './CertificationTestExecutionListPending';
import CertificationTestExecutionListService from '../services/CertificationTestExecutionListService';

class CertificationTestExecutionListPendingContainer extends Component {
  certificationTestListService = new CertificationTestExecutionListService();

  componentDidMount() {
    this.certificationTestListService.init('pending_schedule');
  }

  render() {
    return (
      <CertificationTestExecutionListPending
        certificationTests={toJS(this.certificationTestListService.certificationTests)}
        fetching={this.certificationTestListService.fetch.fetching}
        onLoad={this.certificationTestListService.load}
        onChange={this.certificationTestListService.handleChange}
        pagination={this.certificationTestListService.pagination}
      />
    );
  }
}

export default observer(CertificationTestExecutionListPendingContainer);
